import * as React from "react";
import { FormComponentProps } from "antd/lib/form";
import { TTranslate } from "../../../../service/locale/TranslationService";
import ReportingPeriodApplicantDocumentForm from "./ReportingPeriodApplicantDocumentForm";

export interface State {}

export interface CreateReportingPeriodApplicantDocumentFormProps extends FormComponentProps {
  translate: TTranslate;
  registerFormSubmitEventHandler: any;
  codebooks?: any;
}

class CreateReportingPeriodApplicantDocumentForm extends React.Component<
  CreateReportingPeriodApplicantDocumentFormProps,
  State
> {
  componentDidMount() {
    const { registerFormSubmitEventHandler } = this.props;
    registerFormSubmitEventHandler((e) => {
      e.preventDefault();
      let newFormVersionDocument;
      this.props.form.validateFields((err, values) => {
        if (!err && values) {
          newFormVersionDocument = values;
          newFormVersionDocument.document =
            values.document[0] && values.document[0].originFileObj;
        }
      });
      return newFormVersionDocument;
    });
  }

  render() {
    const { translate, codebooks } = this.props;

    const { getFieldDecorator } = this.props.form;

    return (
      <ReportingPeriodApplicantDocumentForm
        getFieldDecorator={getFieldDecorator}
        translate={translate}
        allowedFileTypes={codebooks?.allowedFileTypes}
      />
    );
  }
}

export default CreateReportingPeriodApplicantDocumentForm;
